
import { ajax } from './helper'
import { SYSPROP_NAMES } from '../component/announcement_bar/constants'
import { getCopBaseUrl } from './constants'

class ApiService {
  async login(body) {
    const loginUrl = 'api/v1/' + 'user/login'
    return await ajax(loginUrl, 'POST', body)
  }

  async getUserList(client, body, signal) {
    const userListUrl = 'api/v1/' + client + '/user_list'
    return await ajax(userListUrl, 'POST', body, true, signal)
  }
  async getSearchByTags(client, body, signal) {
    const searchByTagsUrl = 'api/v1/' + client + '/search_by_tags'
    return await ajax(searchByTagsUrl, 'POST', body, true, signal)
  }

  async getSearchByTagsUsersListDownload(client, body, signal) {
    const searchByTagsUrl = 'api/v1/' + client + '/search_by_tags'
    return await ajax(searchByTagsUrl, 'POST', body, true, signal)
  }

  async clearoutGraphInsights(client, body) {
    const clearoutGraphInsightsUrl = 'api/v1/' + client + '/insights/graph'
    return await ajax(clearoutGraphInsightsUrl, 'POST', body)
  }

  async getClearoutUsersActivities(client, body, cancelToken) {
    const getClearoutUsersListUrl = 'api/v1/' + client + '/user_activities'
    return await ajax(getClearoutUsersListUrl, 'POST', body, cancelToken)
  }

  async createClearoutUser(client, body) {
    const createClearoutUserUrl = 'api/v1/' + client + '/createuser'
    return await ajax(createClearoutUserUrl, 'POST', body)
  }

  async getOrganizationNames(client, body) {
    const getOrganizationListsUrl = 'api/v1/' + client + '/organization/names'
    return await ajax(getOrganizationListsUrl, 'POST', body)
  }

  async getCleaoutUserInfo(client, body) {
    const getClearoutUserInfo = 'api/v1/' + client + '/user_info'
    return await ajax(getClearoutUserInfo, 'POST', body)
  }

  async clearoutUpdateUserEmail(client, body) {
    const clearoutUpdateTimezoneUrl = 'api/v1/' + client + '/email_edit'
    return await ajax(clearoutUpdateTimezoneUrl, 'POST', body)
  }

  async clearoutUpdateTimezone(client, body) {
    const clearoutUpdateTimezoneUrl = 'api/v1/' + client + '/update_timezone'
    return await ajax(clearoutUpdateTimezoneUrl, 'POST', body)
  }

  async giveBonusClearoutUser(client, body) {
    const giveBonusClearoutUserUrl = 'api/v1/' + client + '/bonus'
    return await ajax(giveBonusClearoutUserUrl, 'POST', body)
  }

  async resetBonusClearoutUser(client, body) {
    const resetBonusClearoutUserUrl = 'api/v1/' + client + '/credits/reset'
    return await ajax(resetBonusClearoutUserUrl, 'POST', body)
  }

  async toggleRadar(client, body) {
    const changeRadarStatus = 'api/v1/' + client + '/user/toggle_radar'
    return await ajax(changeRadarStatus, 'POST', body)
  }

  async getClearoutUserProfileAdditionalInfo(client, body) {
    const getClearoutUserProfileAdditionalInfo = 'api/v1/' + client + '/user_profile_additional_info'
    return await ajax(getClearoutUserProfileAdditionalInfo, 'POST', body)
  }

  async updateRateLimitIndividual(client, body) {
    const updateRateLimitIndividualUrl = 'api/v1/' + client + '/user/update_api_ratelimit'
    return await ajax(updateRateLimitIndividualUrl, 'POST', body)
  }

  async removeRateLimitIndividual(client, body) {
    const removeRateLimitIndividualUrl = 'api/v1/' + client + '/user/remove_api_ratelimit'
    return await ajax(removeRateLimitIndividualUrl, 'POST', body)
  }

  async clearoutAddDailyLimit(client, body) {
    const clearoutAddDailyLimitUrl = 'api/v1/' + client + '/set_daily_limit'
    return await ajax(clearoutAddDailyLimitUrl, 'POST', body)
  }

  async clearoutUsersRemoveDailyLimit(client, body) {
    const clearoutUsersRemoveDailyLimitUrl = 'api/v1/' + client + '/remove_daily_limit'
    return await ajax(clearoutUsersRemoveDailyLimitUrl, 'POST', body)
  }

  async clearoutUpdateDailyLimit(client, body) {
    const clearoutUpdateDailyLimitUrl = 'api/v1/' + client + '/update_daily_limit'
    return await ajax(clearoutUpdateDailyLimitUrl, 'POST', body)
  }

  async listInvoices(client, co_user_id) {
    const listInvoicesUrl = 'api/v1/' + client + '/receipts'
    return await ajax(listInvoicesUrl, 'POST', co_user_id)
  }

  async clearoutMarkAsPaid(client, body) {
    const clearoutMarkAsPaidUrl = 'api/v1/' + client + '/mark_as_paid'
    return await ajax(clearoutMarkAsPaidUrl, 'POST', body)
  }

  async logoutAllSessionOfClearoutUser(client, body) {
    const logoutAllSessionOfClearoutUserUrl = 'api/v1/' + client + '/logout'
    return await ajax(logoutAllSessionOfClearoutUserUrl, 'POST', body)
  }

  async blockClearoutUser(client, body) {
    const blockUserApiUrl = 'api/v1/' + client + '/user/block'
    return await ajax(blockUserApiUrl, 'POST', body)
  }

  async unblockClearoutUser(client, body) {
    const unblockUserApiUrl = 'api/v1/' + client + '/user/unblock'
    return await ajax(unblockUserApiUrl, 'POST', body)
  }

  async deleteClearoutUser(client, body) {
    const deleteUserApiUrl = 'api/v1/' + client + '/user/delete'
    return await ajax(deleteUserApiUrl, 'POST', body)
  }

  async resetTokens(client, body) {
    const resetTokensUrl = 'api/v1/' + client + '/reset_tokens'
    return await ajax(resetTokensUrl, 'POST', body)
  }

  async getClearoutUsersList(client, body, signal) {
    const getClearoutUsersListUrl = 'api/v1/' + client + '/user_list'
    return await ajax(getClearoutUsersListUrl, 'POST', body, true, signal)
  }

  async removeEmailFromCache(client, queryParams) {
    const removeEmailFromCacheUrl = 'api/v1/' + client + '/email_verify/remove_email_from_cache'
    const url = `${removeEmailFromCacheUrl}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'DELETE')
  }

  async updateDisposableDomains(client, body) {
    const updatedisposable = 'api/v1/' + client + '/sysprop/update_disposable_domain'
    return await ajax(updatedisposable, 'PUT', body)
  }

  async getTagsNames(client, body) {
    const getTagsNamesUrl = 'api/v1/' + client + '/get_tags'
    return await ajax(getTagsNamesUrl, 'POST', body)
  }

  async overAllUsageReports(client, queryParams) {
    const usageReportsUrl = 'api/v1/' + client + '/report/all'
    const url = `${usageReportsUrl}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  async emailVerifyReports(client, queryParams) {
    const allUsersEmailVerifyList = 'api/v1/' + client + '/report/email_verify'
    const url = `${allUsersEmailVerifyList}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  async emailFinderReports(client, queryParams) {
    const allUsersEmailFinderList = 'api/v1/' + client + '/report/email_finder'
    const url = `${allUsersEmailFinderList}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  async prospectReports(client, queryParams) {
    const allUsersProspectList = 'api/v1/' + client + '/report/prospect'
    const url = `${allUsersProspectList}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  async formGuardReports(client, queryParams) {
    const baseUrl = 'api/v1/' + client + '/report/js_widget'
    const url = `${baseUrl}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  async dataPulseReports(client, queryParams) {
    const baseUrl = 'api/v1/' + client + '/report/data_pulse'
    const url = `${baseUrl}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  async accountStatusUpdateClearoutUser(client, body) {
    const userAccountStatusUpdateUrl = 'api/v1/' + client + '/user/account_status_update'
    return await ajax(userAccountStatusUpdateUrl, 'POST', body)
  }

  async getClearoutUserStatuses(client, body) {
    const coUserStatusApiUrl = 'api/v1/' + client + '/user/statuses'
    return await ajax(coUserStatusApiUrl, 'POST', body)
  }

  async getCoProductList(client, queryParams) {
    const getCoProductListUrl = 'api/v1/' + client + '/product/list'
    let query = new URLSearchParams(queryParams).toString()

    const url = getCoProductListUrl + '?' + query
    return await ajax(url, 'GET')
  }

  async getCoAddonProductInfo(client, queryParams) {
    const getCoAddonProductInfoUrl = 'api/v1/' + client + '/product/addon_info'
    let query = new URLSearchParams(queryParams).toString()

    const url = getCoAddonProductInfoUrl + '?' + query
    return await ajax(url, 'GET')
  }

  async getCoProductDropDownList(client, queryParams) {
    const getCoProductListUrl = 'api/v1/' + client + '/product/drop_down_list'
    let query = new URLSearchParams(queryParams).toString()

    const url = getCoProductListUrl + '?' + query
    return await ajax(url, 'GET')
  }


  async getProduct(client, queryParams) {
    const getProductUrl = 'api/v1/' + client + '/product/view'
    let query = new URLSearchParams(queryParams)
    const url = getProductUrl + '?' + query
    return await ajax(url, 'GET')
  }

  async createProduct(client, body) {
    const createProductUrl = 'api/v1/' + client + '/product/create'
    return await ajax(createProductUrl, 'POST', body)
  }

  async udpateUserPaymentSettings(client, body) {
    const udpateUserPaymentSettingsUrl = 'api/v1/' + client + '/user/payment_settings_update'
    return await ajax(udpateUserPaymentSettingsUrl, 'PATCH', body)
  }

  async attachProduct(client, body) {
    const attachProductUrl = 'api/v1/' + client + '/product/attach'
    return await ajax(attachProductUrl, 'POST', body)
  }

  async detachProduct(client, body) {
    const detachProductUrl = 'api/v1/' + client + '/product/detach'
    return await ajax(detachProductUrl, 'POST', body)
  }

  async attachBfsProduct(client, body) {
    const attachBfsProductUrl = 'api/v1/' + client + '/bfs_product/attach'
    return await ajax(attachBfsProductUrl, 'POST', body)
  }

  async detachBFSProduct(client, body) {
    const detachBfsProductUrl = 'api/v1/' + client + '/bfs_product/detach'
    return await ajax(detachBfsProductUrl, 'POST', body)
  }

  async preBfs(client, body) {
    const preBfsUrl = 'api/v1/' + client + '/pre_bfs'
    return await ajax(preBfsUrl, 'POST', body)
  }

  async postBfs(client, body) {
    const postBfsUrl = 'api/v1/' + client + '/post_bfs'
    return await ajax(postBfsUrl, 'POST', body)
  }

  async bfsLaunch(client, body) {
    const bfsLaunchUrl = 'api/v1/' + client + '/bfs_launch'
    return await ajax(bfsLaunchUrl, 'POST', body)
  }

  async getOrganizationLists(client, body, signal) {
    const getOrganizationListsUrl = 'api/v1/' + client + '/organization/list'
    return await ajax(getOrganizationListsUrl, 'POST', body, true, signal)
  }

  async getOrganizationInfo(client, body) {
    const getOrganizationInfoUrl = 'api/v1/' + client + '/organization_info'
    return await ajax(getOrganizationInfoUrl, 'POST', body)
  }

  async giveBonusClearoutOrg(client, body) {
    const giveBonusClearoutOrgUrl = 'api/v1/' + client + '/organization_bonus'
    return await ajax(giveBonusClearoutOrgUrl, 'POST', body)
  }

  async getUsersPlansAndActiveSubscriptions(client, queryParams) {
    const getProductUrl = 'api/v1/' + client + '/plan/list'
    let query = new URLSearchParams(queryParams)
    const url = getProductUrl + '?' + query
    return await ajax(url, 'GET')
  }

  async resetClearoutOrgCredits(client, body) {
    const resetClearoutOrgCreditsUrl =
      'api/v1/' + client + '/organization/credits/reset'
    return await ajax(resetClearoutOrgCreditsUrl, 'POST', body)
  }

  async updateRateLimitOrg(client, body) {
    const updateRateLimitOrgUrl = 'api/v1/' + client + '/organization/update_api_ratelimit'
    return await ajax(updateRateLimitOrgUrl, 'POST', body)
  }

  async removeRateLimitOrg(client, body) {
    const removeRateLimitOrgUrl = 'api/v1/' + client + '/organization/remove_api_ratelimit'
    return await ajax(removeRateLimitOrgUrl, 'POST', body)
  }

  async updateOrgDailyLimit(client, body) {
    const updateOrgDailyLimitUrl =
      'api/v1/' + client + '/organization/update_daily_limit'
    return await ajax(updateOrgDailyLimitUrl, 'POST', body)
  }

  async clearoutOrgAddDailyLimit(client, body) {
    const clearoutOrgAddDailyLimitUrl =
      'api/v1/' + client + '/organization/update_allowed_daily_limit'
    return await ajax(clearoutOrgAddDailyLimitUrl, 'POST', body)
  }

  async updateOrgAllocateSeat(client, body) {
    const updateOrgDailyLimitUrl =
      'api/v1/' + client + '/organization/update_member_seat_limit'
    return await ajax(updateOrgDailyLimitUrl, 'POST', body)
  }

  async getSystemRadarSettings(client, queryParams) {
    const getSystemRadarSettingsUrl = 'api/v1/' + client + '/radar/settings_list'
    const url = `${getSystemRadarSettingsUrl}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  async getCopSystemRadarSettings(client, queryParams) {
    const getCopSystemRadarSettingsUrl = getCopBaseUrl(client) + 'crm/radar/settings/list'
    let query = new URLSearchParams(queryParams).toString()
    const url = getCopSystemRadarSettingsUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async updateSystemRadarSettings(client, body) {
    const updateSystemRadarSettingsUrl = 'api/v1/' + client + '/radar/settings_update'
    return await ajax(updateSystemRadarSettingsUrl, 'PUT', body)
  }

  async updateCopSystemRadarSettings(client, body) {
    const updateCopSystemRadarSettingsUrl = getCopBaseUrl(client) + 'crm/radar/settings/update'
    return await ajax(updateCopSystemRadarSettingsUrl, 'PUT', body, false, null, false)
  }

  async udpateUserDefaultPaymentAccount(client, body) {
    const udpateUserDefaultPaymentAccountgsUrl = 'api/v1/' + client + '/user/payment_account_update'
    return await ajax(udpateUserDefaultPaymentAccountgsUrl, 'PATCH', body)
  }


  async getAbuseListWrtCountry(client, body) {
    const addAbuseListsUrl = 'api/v1/' + client + '/abuse_list/country'
    return await ajax(addAbuseListsUrl, 'POST', body)
  }

  async addAbuseListEntry(client, body) {
    const addAbuseListsUrl = 'api/v1/' + client + '/abuse_list/add'
    return await ajax(addAbuseListsUrl, 'POST', body)
  }

  async signUpAbuseLimiter(client, body) {
    const signUpAbuseLimiterUrl = 'api/v1/' + client + '/signup_abuse_limiter'
    return await ajax(signUpAbuseLimiterUrl, 'POST', body)
  }

  async getAbuseList(client, body, signal) {
    const getAbuseListsUrl = 'api/v1/' + client + '/abuse_list'
    return await ajax(getAbuseListsUrl, 'POST', body, true, signal)
  }

  async listCoupons(client, body, signal) {
    const listCouponsUrl = 'api/v1/' + client + '/coupon/list'
    return await ajax(listCouponsUrl, 'POST', body, true, signal)
  }

  async createCoupon(client, body) {
    const createCouponUrl = 'api/v1/' + client + '/coupon/create'
    return await ajax(createCouponUrl, 'POST', body)
  }

  async editCoupon(client, body) {
    const editCouponUrl = 'api/v1/' + client + '/coupon/edit'
    return await ajax(editCouponUrl, 'POST', body)
  }

  async updateAbuseListEntry(client, body) {
    const updateAbuseListsUrl = 'api/v1/' + client + '/abuse_list/update'
    return await ajax(updateAbuseListsUrl, 'POST', body)
  }

  async getClearoutAbuseActivityLogs(client, body, signal) {
    const getClearoutAbuseActivityUrl = 'api/v1/' + client + '/abuse_activity'
    return await ajax(getClearoutAbuseActivityUrl, 'POST', body, true, signal)
  }

  async getClearoutAbuseUpdateLogs(client, body, signal) {
    const getClearoutAbuseUpdateActivityUrl = 'api/v1/' + client + '/abuse_update_activity'
    return await ajax(getClearoutAbuseUpdateActivityUrl, 'POST', body, true, signal)
  }

  async getUserSubscriptions(client, queryParams) {
    const getUserSubscriptionsUrl = 'api/v1/' + client + '/user_subscription/list'
    let query = new URLSearchParams(queryParams).toString()
    const url = getUserSubscriptionsUrl + '?' + query
    return await ajax(url, 'GET')
  }

  async getClearoutEVLists(client, body, cancelToken) {
    const getClearoutListsUrl = `api/v1/${client}/list`;
    return await ajax(getClearoutListsUrl, 'POST', body, true, cancelToken);
  }

  async downloadEVListInputFile(client, inputFileKey) {
    const downloadInputFile = `api/v1/${client}/download/input_file`;
    return await ajax(downloadInputFile, 'POST', inputFileKey);
  }

  async getClearoutOrgUsersList(client, body, signal) {
    const getClearoutUsersListUrl = `api/v1/${client}/org_users/list`;
    return await ajax(getClearoutUsersListUrl, 'POST', body, true, signal);
  }

  async downloadresultForEVList(client, body) {
    const downloadresultForEVListUrl = `api/v1/${client}/download/result`;
    return await ajax(downloadresultForEVListUrl, 'POST', body);
  }

  async getClearoutProspectRequests(client, body) {
    const getProspectRequestsUrl = `api/v1/${client}/prospect/requests`;
    return await ajax(getProspectRequestsUrl, 'POST', body, true, null)
  }
  async getEmailFinderLists(client, body, signal) {
    const getClearoutEmailFinderListsUrl = `api/v1/${client}/email_finder/list`;
    return await ajax(getClearoutEmailFinderListsUrl, 'POST', body, true, signal);
  }

  async downloadEmailFinderInputFile(client, inputFileKey) {
    const downloadEmailFinderInputFile = `api/v1/${client}/download/email_finder_input_file`;
    return await ajax(downloadEmailFinderInputFile, 'POST', inputFileKey);
  }

  async downloadEmailFinderResultFile(client, body) {
    const downloadEmailFinderResultFile = `api/v1/${client}/download/email_finder_result`;
    return await ajax(downloadEmailFinderResultFile, 'POST', body);
  }

  async getProspectLists(client, body, signal) {
    const getProspectListUrl = `api/v1/${client}/prospect/list`
    return await ajax(getProspectListUrl, 'POST', body, true, signal)
  }

  async downloadProspectResultFile(client, body) {
    const getProspectRequestsUrl = `api/v1/${client}/prospect/export`
    return await ajax(getProspectRequestsUrl, 'POST', body)
  }

  async getPendingInvoicesList(client, queryParams) {
    const listInvoicesUrl = 'api/v1/' + client + '/payment/pending_invoices'
    const url = listInvoicesUrl + '?' + new URLSearchParams(queryParams).toString()

    return await ajax(url, 'GET')
  }

  async findUsersByGatewayEmail(client, queryParams) {
    const findEmailFromCacheUrl = 'api/v1/' + client + '/payment/gateway_email_lookup'
    const url = `${findEmailFromCacheUrl}?${new URLSearchParams(queryParams).toString()}`
    return await ajax(url, 'GET')
  }

  //cop api's
  async getClearoutPhoneUsersList(client, body, signal) {
    const getClearoutUsersListUrl = getCopBaseUrl(client) + 'crm/user/list'
    return await ajax(
      getClearoutUsersListUrl,
      'POST',
      body,
      false,
      signal,
      false
    )
  }

  async createClearoutPhoneUser(client, body) {
    const createClearoutPhoneUserUrl = getCopBaseUrl(client) + 'crm/user/createuser'
    return await ajax(createClearoutPhoneUserUrl, 'POST', body, false, null, false)
  }

  async getCopUserInfo(client, body) {
    const getClearoutUserInfo = getCopBaseUrl(client) + 'crm/user/info'
    return await ajax(
      getClearoutUserInfo,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async getClearoutPhoneUserProfileAdditionalInfo(client, body) {
    const createClearoutPhoneUserUrl = getCopBaseUrl(client) + 'crm/user/user_profile_additional_info'
    return await ajax(createClearoutPhoneUserUrl, 'POST', body, false, null, false)
  }

  async giveBonusCopUser(client, body) {
    const giveBonusCopUserUrl = getCopBaseUrl(client) + 'crm/user/bonus'
    return await ajax(
      giveBonusCopUserUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async resetBonusCopUser(client, body) {
    const resetBonusCopUserUrl =
      getCopBaseUrl(client) + 'crm/user/credits/reset'
    return await ajax(
      resetBonusCopUserUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async clearoutPhoneUpdateTimezone(client, body) {
    const clearoutUpdateTimezoneUrl =
      getCopBaseUrl(client) + 'crm/user/timezone/edit'
    return await ajax(
      clearoutUpdateTimezoneUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async copResetTokens(client, body) {
    const resetTokensUrl = getCopBaseUrl(client) + 'crm/user/reset_tokens'
    return await ajax(resetTokensUrl, 'POST', body, false, null, false)
  }

  async logoutCopAllSessionOfClearoutUser(client, body) {
    const logoutAllSessionOfClearoutUserUrl =
      getCopBaseUrl(client) + 'crm/user/sessions/deactivate'
    return await ajax(
      logoutAllSessionOfClearoutUserUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async clearoutPhoneAddDailyLimit(client, body) {
    const clearoutAddDailyLimitUrl =
      getCopBaseUrl(client) + 'crm/user/set_daily_limit'
    return await ajax(
      clearoutAddDailyLimitUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async clearoutPhoneUsersRemoveDailyLimit(client, body) {
    const clearoutUsersRemoveDailyLimitUrl =
      getCopBaseUrl(client) + 'crm/user/remove_daily_limit'
    return await ajax(
      clearoutUsersRemoveDailyLimitUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async clearoutPhoneUpdateDailyLimit(client, body) {
    const clearoutUpdateDailyLimitUrl =
      getCopBaseUrl(client) + 'crm/user/update_daily_limit'
    return await ajax(
      clearoutUpdateDailyLimitUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async updateRateLimitForCOPIndividual(client, body) {
    const updateRateLimitForCOPIndividualUrl =
      getCopBaseUrl(client) + 'crm/update_api_ratelimit'
    return await ajax(updateRateLimitForCOPIndividualUrl, 'POST', body, false, null, false)
  }

  async removeRateLimitForCOPIndividual(client, body) {
    const removeRateLimitForCOPIndividualUrl =
      getCopBaseUrl(client) + 'crm/remove_api_ratelimit'
    return await ajax(removeRateLimitForCOPIndividualUrl, 'POST', body, false, null, false)
  }

  async listCopInvoices(client, body) {
    const listInvoicesUrl = getCopBaseUrl(client) + 'crm/user/receipts'
    return await ajax(listInvoicesUrl, 'POST', body, false, null, false)
  }

  async clearoutPhoneMarkAsPaid(client, body) {
    const clearoutPhoneMarkAsPaidUrl =
      getCopBaseUrl(client) + 'crm/user/mark_as_paid'
    return await ajax(
      clearoutPhoneMarkAsPaidUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }
  async clearoutPhoneUpdateUserEmail(client, body) {
    const clearoutPhoneUpdateEmailUrl =
      getCopBaseUrl(client) + 'crm/email_edit'
    return await ajax(
      clearoutPhoneUpdateEmailUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async blockClearoutPhoneUser(client, body) {
    const blockClearoutPhoneUserUrl =
      getCopBaseUrl(client) + 'crm/user/block_user'
    return await ajax(
      blockClearoutPhoneUserUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async unBlockClearoutPhoneUser(client, body) {
    const unBlockClearoutPhoneUserUrl =
      getCopBaseUrl(client) + 'crm/user/unblock_user'
    return await ajax(
      unBlockClearoutPhoneUserUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async deleteClearoutPhoneUser(client, body) {
    const deleteClearoutPhoneUserUrl =
      getCopBaseUrl(client) + 'crm/user/user_delete'
    return await ajax(
      deleteClearoutPhoneUserUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async listCopCoupons(client, body, signal) {
    const listCouponsUrl = getCopBaseUrl(client) + 'crm/coupon/list'
    return await ajax(listCouponsUrl, 'POST', body, false, signal, false)
  }

  async createCopCoupon(client, body) {
    const createCouponUrl = getCopBaseUrl(client) + 'crm/coupon/create'
    return await ajax(createCouponUrl, 'POST', body, false, null, false)
  }

  async editCopCoupon(client, body) {
    const editCouponUrl = getCopBaseUrl(client) + 'crm/coupon/edit'
    return await ajax(editCouponUrl, 'POST', body, false, null, false)
  }

  async getCopAbuseList(client, body, signal) {
    const getAbuseListsUrl = getCopBaseUrl(client) + 'crm/abuse_list'
    return await ajax(
      getAbuseListsUrl,
      'POST',
      body,
      false,
      signal,
      false
    )
  }

  async addCopAbuseListEntry(client, body) {
    const addAbuseListsUrl = getCopBaseUrl(client) + 'crm/abuse_list/add'
    return await ajax(
      addAbuseListsUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async getCopAbuseListWrtCountry(client, body) {
    const addAbuseListsUrl = getCopBaseUrl(client) + 'crm/abuse_list/country'
    return await ajax(
      addAbuseListsUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async copSignUpAbuseLimiter(client, body) {
    const signUpAbuseLimiterUrl =
      getCopBaseUrl(client) + 'crm/signup_abuse_limiter'
    return await ajax(
      signUpAbuseLimiterUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async updateCopAbuseListEntry(client, body) {
    const updateAbuseListsUrl =
      getCopBaseUrl(client) + 'crm/abuse_list/update'
    return await ajax(
      updateAbuseListsUrl,
      'POST',
      body,
      false,
      null,
      false
    )
  }

  async getClearoutPhoneAbuseActivityLogs(client, body, signal) {
    const updateAbuseListsUrl =
      getCopBaseUrl(client) + 'crm/abuse_activity'
    return await ajax(
      updateAbuseListsUrl,
      'POST',
      body,
      false,
      signal,
      false
    )
  }

  async getClearoutPhoneAbuseUpdateLogs(client, body, signal) {
    const updateAbuseActivityUrl =
      getCopBaseUrl(client) + 'crm/abuse_update_activity'
    return await ajax(
      updateAbuseActivityUrl,
      'POST',
      body,
      false,
      signal,
      false
    )
  }

  async getCopUsersActivities(client, body, signal) {
    const getCopUsersActivitiesUrl =
      getCopBaseUrl(client) + 'crm/user_activities'
    return await ajax(
      getCopUsersActivitiesUrl,
      'POST',
      body,
      false,
      signal,
      false
    )
  }
  async getCopUsersPlansAndActiveSubscriptions(client, queryParams) {
    const getCopUsersPlansAndActiveSubscriptionsUrl = getCopBaseUrl(client) + 'crm/plan/list'
    let query = new URLSearchParams(queryParams).toString()
    const url = getCopUsersPlansAndActiveSubscriptionsUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async clearoutPhoneUserSubsList(client, queryParams) {
    const clearoutPhoneUserSubsListUrl =
      getCopBaseUrl(client) + 'crm/user_subscription/list';
    let query = new URLSearchParams(queryParams).toString();
    const url = clearoutPhoneUserSubsListUrl + '?' + query;
    return await ajax(
      url,
      'GET',
      null,
      false,
      null,
      false
    );
  }

  async getCopLists(client, body, signal) {
    const getCopListsUrl = getCopBaseUrl(client) + 'crm/user/added_list';
    return await ajax(getCopListsUrl, 'POST', body, false, signal, false);
  }

  async downloadCopInputFile(client, body, signal) {
    const downloadResultUrl =
      getCopBaseUrl(client) + 'crm/user/download/input_file';
    return await ajax(
      downloadResultUrl,
      'POST',
      body,
      false,
      signal,
      false
    );
  }

  async downloadresultForPhoneClearoutList(client, body, signal) {
    const downloadresultForClearoutListUrl =
      getCopBaseUrl(client) + 'crm/user/download/result';
    return await ajax(
      downloadresultForClearoutListUrl,
      'POST',
      body,
      false,
      signal,
      false
    );
  }

  async getCopProductList(client, queryParams) {
    const getCopProductListUrl = getCopBaseUrl(client) + 'crm/payment/product/lists'
    let query = new URLSearchParams(queryParams).toString()

    const url = getCopProductListUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async getCopAddonProductInfo(client, queryParams) {
    const getCopAddonProductInfoUrl = getCopBaseUrl(client) + 'crm/payment/product/addon_info'
    let query = new URLSearchParams(queryParams).toString()

    const url = getCopAddonProductInfoUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async getCopProductDropDownList(client, queryParams) {
    const getCopProductListUrl = getCopBaseUrl(client) + 'crm/payment/product/drop_down_list'
    let query = new URLSearchParams(queryParams).toString()

    const url = getCopProductListUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async getCopProduct(client, queryParams) {
    const getCopProductUrl = getCopBaseUrl(client) + 'crm/payment/product/view'
    let query = new URLSearchParams(queryParams)
    const url = getCopProductUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async createCopProduct(client, body) {
    const createCopProductUrl = getCopBaseUrl(client) + 'crm/payment/product/create'
    return await ajax(createCopProductUrl, 'POST', body, false, null, false)
  }

  async udpateCopUserPaymentSettings(client, body) {
    const udpateCopUserPaymentSettingsUrl = getCopBaseUrl(client) + 'crm/payment/settings/update'
    return await ajax(udpateCopUserPaymentSettingsUrl, 'PATCH', body, false, null, false)
  }

  async attachCopProduct(client, body) {
    const attachCopProductUrl = getCopBaseUrl(client) + 'crm/payment/product/attach'
    return await ajax(attachCopProductUrl, 'POST', body, false, null, false)
  }

  async detachCopProduct(client, body) {
    const detachCopProductUrl = getCopBaseUrl(client) + 'crm/payment/product/detach'
    return await ajax(detachCopProductUrl, 'POST', body, false, null, false)
  }

  async attachCopBfsProduct(client, body) {
    const attachBfsCopProductUrl = getCopBaseUrl(client) + 'crm/bfs/product/attach'
    return await ajax(attachBfsCopProductUrl, 'POST', body, false, null, false)
  }

  async detachCopBFSProduct(client, body) {
    const detachBfsCopProductUrl = getCopBaseUrl(client) + 'crm/bfs/product/detach'
    return await ajax(detachBfsCopProductUrl, 'POST', body, false, null, false)
  }

  async preBfsCop(client, body) {
    const preBfsCopUrl = getCopBaseUrl(client) + 'crm/bfs/pre_launch'
    return await ajax(preBfsCopUrl, 'POST', body, false, null, false)
  }

  async postBfsCop(client, body) {
    const postBfsCopUrl = getCopBaseUrl(client) + 'crm/bfs/end'
    return await ajax(postBfsCopUrl, 'POST', body, false, null, false)
  }

  async bfsLaunchCop(client, body) {
    const bfsLaunchCopUrl = getCopBaseUrl(client) + 'crm/bfs/launch'
    return await ajax(bfsLaunchCopUrl, 'POST', body, false, null, false)
  }

  async udpateCopUserDefaultPaymentAccount(client, body) {
    const udpateCopUserDefaultPaymentAccountgsUrl = getCopBaseUrl(client) + 'crm/payment/default_account/update'
    return await ajax(udpateCopUserDefaultPaymentAccountgsUrl, 'PATCH', body, false, null, false)
  }

  async copToggleRadar(client, body) {
    const changeRadarStatus = getCopBaseUrl(client) + 'crm/user/toggle_radar'
    return await ajax(changeRadarStatus, 'POST', body, false, null, false)
  }

  async loginWhitelist(client, body) {
    const loginWhitelistUrl = 'api/v1/' + client + '/login_whitelist'
    return await ajax(loginWhitelistUrl, 'POST', body)
  }

  async getCopPendingInvoicesList(client, queryParams) {
    const listInvoicesUrl = getCopBaseUrl(client) + 'crm/payment/pending_invoices'
    let query = new URLSearchParams(queryParams)
    const url = listInvoicesUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async copLoginWhiteList(client, body) {
    const loginWhitelistUrl = getCopBaseUrl(client) + 'crm/login_whitelist'
    return await ajax(loginWhitelistUrl, 'POST', body, false, null, false)
  }
  
  async findCopUsersByGatewayEmail(client, queryParams) {
    const findEmailFromCacheUrl = getCopBaseUrl(client) + 'crm/payment/gateway_email_lookup'
    let query = new URLSearchParams(queryParams)
    const url = findEmailFromCacheUrl + '?' + query
    return await ajax(url, 'GET', null, false, null, false)
  }

  async updateSysprop(client, body) {
    const updateSyspropUrl = `api/v1/${client}/sysprop/update`;
    return await ajax(updateSyspropUrl, 'POST', body);
  }
  async removeSysprop(client, body) {
    const removeSyspropUrl = `api/v1/${client}/sysprop/remove`;
    return await ajax(removeSyspropUrl, 'POST', body);
  }
  async getPublicAnnouncement(client) {
    const getsyspropUrl = `api/v1/${client}/sysprop/get`
    return await ajax( getsyspropUrl, 'POST', {'name': SYSPROP_NAMES.PUBLIC_ANNOUNCEMENT})
  }
  async getUserAnnouncement(client) {
    const getsyspropUrl = `api/v1/${client}/sysprop/get`
    return await ajax( getsyspropUrl, 'POST', {'name': SYSPROP_NAMES.USER_ANNOUNCEMENT})
  }
  async getCopAppAnnouncement(client) {
    return await ajax(getCopBaseUrl(client) + 'v1/app/announcement', 'GET', null, false, null, false)
  }
  async getCopSyspropValue(client, body) {
    const getCopSyspropUrl = getCopBaseUrl(client) + 'crm/sysprop/get'
    return await ajax(getCopSyspropUrl, 'POST', body, false, null, false)
  }
  async updateCopSysprop(client, body) {
    let crmProxyResponse
    try {
      crmProxyResponse = await this.updateSysprop(client, body)
    } catch {
      crmProxyResponse = null
    }

    if (crmProxyResponse && crmProxyResponse.status === 'success') {
      return crmProxyResponse
    }

    const updateCopSyspropUrl = getCopBaseUrl(client) + 'crm/sysprop/update'
    const copResponse = await ajax(updateCopSyspropUrl, 'POST', body, false, null, false)
    if (copResponse && copResponse.status === 'success') {
      return copResponse
    }

    return crmProxyResponse || copResponse
  }

  async checkSystemProperty(client, body) {
    const checkSystemPropertyUrl = `api/v1/${client}/system_property/check`
    return await ajax(checkSystemPropertyUrl, 'POST', body)
  }

  async updateSystemProperty(client, body) {
    const updateSystemPropertyUrl = `api/v1/${client}/system_property/update`
    return await ajax(updateSystemPropertyUrl, 'POST', body)
  }


  async getProspectPerson(client, queryParams) {
    const getProspectPersonUrl = `api/v1/${client}/prospect/person`;
    const query = { ...queryParams };
    const url = `${getProspectPersonUrl}?${new URLSearchParams(query).toString()}`;
    return await ajax(url, 'GET');
  }
  async updateProspectPersonVisibility(client, body) {
    const updateProspectPersonVisibilityUrl = `api/v1/${client}/prospect/person/visibility`;
    return await ajax(updateProspectPersonVisibilityUrl, 'POST', body);
  }
  async buySubscription(client, body) {
    const buySubscriptionUrl = 'api/v1/' + client + '/payment/buy'
    return await ajax(buySubscriptionUrl, 'POST', body)
  }
  async cancelSubscription(client, body) {
    const cancelUrl = 'api/v1/' + client + '/payment/cancel'
    return await ajax(cancelUrl, 'POST', body)
  }
  async renewSubscription(client, body) {
    const renewUrl = 'api/v1/' + client + '/payment/renew'
    return await ajax(renewUrl, 'POST', body)
  }
  async getPlanInfo(client, queryParams) {
    const getPlanInfoUrl = `api/v1/${client}/plan/info`;
    const query = { ...queryParams };
    const url = `${getPlanInfoUrl}?${new URLSearchParams(query).toString()}`;
    return await ajax(url, 'GET');
  }

  // ---- Data Pulse free trials ----
  // sfcloud BFF: POST api/v1/{client}/data_pulse/free_trial/<op>
  // `list` is requested-but-not-yet-shipped (see docs/data_pulse_free_trial_api_gaps.md, G1).
  async getDataPulseTrials(client, body, signal) {
    const url = 'api/v1/' + client + '/data_pulse/free_trial/list'
    return await ajax(url, 'POST', body, true, signal)
  }
  async getDataPulseTrialMetrics(client, body, signal) {
    const url = 'api/v1/' + client + '/data_pulse/free_trial/metrics'
    return await ajax(url, 'POST', body, true, signal)
  }
  async getDataPulseTrialStatus(client, body) {
    const url = 'api/v1/' + client + '/data_pulse/free_trial/status'
    return await ajax(url, 'POST', body)
  }
  async extendDataPulseTrial(client, body) {
    const url = 'api/v1/' + client + '/data_pulse/free_trial/extend'
    return await ajax(url, 'POST', body)
  }
  async expireDataPulseTrial(client, body) {
    const url = 'api/v1/' + client + '/data_pulse/free_trial/expire'
    return await ajax(url, 'POST', body)
  }
  async reenableDataPulseTrial(client, body) {
    const url = 'api/v1/' + client + '/data_pulse/free_trial/re_enable'
    return await ajax(url, 'POST', body)
  }

  // Accounts for the analytics account picker. sfcloud BFF: POST api/v1/{client}/data_pulse/list_accounts
  async getDataPulseAccounts(client, body) {
    const url = 'api/v1/' + client + '/data_pulse/list_accounts'
    return await ajax(url, 'POST', body)
  }

  // Fair-share admission live stats for the CRM dashboard. sfcloud BFF: POST api/v1/{client}/data_pulse/fair_usage_stats
  async getDataPulseFairUsageStats(client, body, signal) {
    const url = 'api/v1/' + client + '/data_pulse/fair_usage_stats'
    return await ajax(url, 'POST', body, true, signal)
  }

  // A user's currently configured Data Pulse concurrency limits. sfcloud BFF: POST api/v1/{client}/data_pulse/user_concurrency_limit
  async getDataPulseUserConcurrencyLimit(client, body, signal) {
    const url = 'api/v1/' + client + '/data_pulse/user_concurrency_limit'
    return await ajax(url, 'POST', body, true, signal)
  }

  // An org's currently configured Data Pulse concurrency limits. sfcloud BFF: POST api/v1/{client}/data_pulse/org_concurrency_limit
  async getDataPulseOrgConcurrencyLimit(client, body, signal) {
    const url = 'api/v1/' + client + '/data_pulse/org_concurrency_limit'
    return await ajax(url, 'POST', body, true, signal)
  }

  // Set a user's Data Pulse concurrency min/max. sfcloud BFF: POST api/v1/{client}/data_pulse/update_user_concurrency_limit
  async updateDataPulseUserConcurrencyLimit(client, body) {
    const url = 'api/v1/' + client + '/data_pulse/update_user_concurrency_limit'
    return await ajax(url, 'POST', body)
  }

  // Set an org's Data Pulse concurrency min/max. sfcloud BFF: POST api/v1/{client}/data_pulse/update_org_concurrency_limit
  async updateDataPulseOrgConcurrencyLimit(client, body) {
    const url = 'api/v1/' + client + '/data_pulse/update_org_concurrency_limit'
    return await ajax(url, 'POST', body)
  }

}

export default new ApiService()